import { ProviderType } from 'src/types/provider';

export const getProvider = (providers: ProviderType[]): ProviderType => {
    let provider = null;

    if (localStorage.getItem('eshopKey')) {
        provider = providers.find((item: ProviderType) => item.ESHOP_KEY === localStorage.getItem('eshopKey'));
    }

    if (!provider) {
        provider = providers[0];
    }

    return provider;
};
